import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'reactstrap';
import DietPlanMainHeader from './DietPlanMainHeader';
import MeetTheExperts from './MeetTheExperts';
import SuccessStories from './SuccessStories';
import WeightChart from './weight-chart.svg';
import { sendFirebaseEvent } from '../../../helper/mobile';

const DietPlanMain = () => {
    return (
        <>
            <DietPlanMainHeader />
            <Container className='ps-4 pe-4'>
                <h3 className='clients-lost mt-4 mb-3'><span>93%</span> of our clients lost <span>3.2kg*</span> in one month</h3>
                <img className='weight-chart mb-2' src={WeightChart} alt="" />
                <MeetTheExperts />
            </Container>
            <SuccessStories />
            <div className="empty-space-82"></div>
            <div className="fix-div-button">
                <Link to="/dietPlan/healthConditions" onClick={() => sendFirebaseEvent('diet_plan_get_started_btn', 'click_event')}>
                    <Button className="risk-btn">Get started</Button>
                </Link>
            </div>
        </>
    );
}

export default DietPlanMain;